import CollectionsBootstrap from 'modules/permissions/lib/SettingsCollectionsBootstrap'
import PermissionsContainer from 'modules/permissions/pages/settings/PermissionsContainer'

const Container = () => {
  return <PermissionsContainer />
}

const PermissionsRootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default PermissionsRootPage
